<template>
  <div class="document-container">
    <div class="doc-name">
      <p class="name">申请接入</p>
      <p class="update-time">{{currentParams.updateTime}}</p>
    </div>
    <div class="request-module-box">
      <div class="module-name">
        <span>申请说明</span>
      </div>
      <div class="module-text">
        <span>1、如果您是油柑网的已有客户，或者是有意愿与油柑网进行深度合作的采购商，都可以申请接入油柑网开放平台。我们会秉承全心全力为客户服务的态度，就每个采购商的申请进行单独审核</span>
      </div>
      <div class="module-text">
        <span>
          2、您需要首先前往
          <a target="_blank" href="https://shimo.im/forms/3gkjJGPyhxTCWVCK/fill">这里</a>,填写油柑网对外接口合作商信息表单。
        </span>
      </div>
      <div class="module-text">
        <span>3、请注意，当您填写联系人手机号码时，请不要填写已经注册了油柑网的手机号码，因为这个手机号码在开通对外接口后会被禁止登陆油柑网。</span>
      </div>
      <div class="module-text">
        <span>4、您完整填写表单并提交后，我们会在10个工作日内联系您，并与您讨论具体的接入方式。</span>
      </div>
    </div>
  </div>
</template>
<script>
import Tables from "@/components/Tables";
import publicData from "@/api/public/index";
import { createOrderApi } from "@/api/order/index";
export default {
  components: {
    Tables
  },
  data() {
    return {
      publicParams: publicData,
      currentParams: createOrderApi
    };
  }
};
</script>
<style lang="less" scoped>
.document-container {
  padding: 0 40px;
  text-align: left;
  .doc-name {
    border-bottom: 1px solid #dedede;
    > .name {
      font-size: 24px;
      text-align: left;
      color: #333;
    }
    > .update-time {
      margin-top: 10px;
      margin-bottom: 30px;
      font-size: 12px;
      color: #666666;
    }
  }
  .request-module-box {
    .module-name {
      height: 60px;
      font-size: 16px;
      line-height: 60px;
      color: #333;
    }
    .table-box {
    }
    .module-text {
      font-size: 14px;
      line-height: 40px;
      text-align: justify;
      a {
        color: #4fbfff;
        text-decoration: underline;
      }
    }
    .module-img {
      margin-top: 10px;
      img {
        width: 100%;
        display: block;
      }
    }
    .code-example {
      background-color: #e8e8e8;
    }
  }
}
</style>